"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FinanceElementsTypes;
(function (FinanceElementsTypes) {
    FinanceElementsTypes["INTEREST_RATE"] = "interestRate";
    FinanceElementsTypes["COMPARISON_RATE"] = "comparisonRate";
    FinanceElementsTypes["CHOSEN_TERM"] = "chosenTerm";
    FinanceElementsTypes["CHOSEN_RATE"] = "chosenRate";
    FinanceElementsTypes["TERM"] = "term";
    FinanceElementsTypes["TERM_IN_YEARS"] = "termInYears";
    FinanceElementsTypes["DEPOSIT_PERCENTAGE"] = "depositPercentage";
    FinanceElementsTypes["MONTHLY_INTEREST"] = "monthlyInterest";
    FinanceElementsTypes["FINANCE_DEPOSIT"] = "financeDeposit";
    FinanceElementsTypes["REPAYMENT"] = "Repayment";
    FinanceElementsTypes["CAP_COMPARISON_RATE"] = "ComparisonRate";
})(FinanceElementsTypes || (FinanceElementsTypes = {}));
exports.default = FinanceElementsTypes;
